import React from "react";
import { AlertCircle, ArrowRight, MessageCircle } from "lucide-react";
import { SKOOL_URL } from "@/lib/salesClosed";

/**
 * Post-deadline panel that replaces the ticket grid once sales close.
 * Directs late buyers to contact Jacob on Skool.
 */
export default function SalesClosedPanel() {
  return (
    <div
      data-testid="sales-closed-panel"
      className="relative overflow-hidden rounded-3xl bg-white text-[#0A1128] border-2 border-[#FACC15] shadow-[0_25px_60px_-30px_rgba(250,204,21,0.5)]"
    >
      <div className="absolute -top-24 -left-16 w-80 h-80 bg-[#FACC15]/25 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute -bottom-20 -right-16 w-96 h-96 bg-[#0066FF]/15 rounded-full blur-3xl pointer-events-none" />

      <div className="relative p-8 md:p-12 lg:p-14">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-red-50 border border-red-200 text-red-700 rounded-full mb-6 text-[10px] md:text-xs font-black uppercase tracking-[0.28em]">
            <AlertCircle size={12} /> The Deadline Has Passed
          </div>

          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#0A1128] leading-[0.95] mb-6">
            It&apos;s the deadline.
          </h2>

          <p className="text-lg md:text-2xl text-[#374151] leading-relaxed mb-8 max-w-2xl">
            But if you&apos;re still interested in coming, message <strong className="text-[#0A1128]">Jacob directly</strong>.
          </p>

          <a
            href={SKOOL_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="sales-closed-skool-cta"
            className="inline-flex items-center gap-2 bg-[#0A1128] hover:bg-[#0066FF] text-white font-black uppercase tracking-[0.15em] text-sm md:text-base px-7 py-4 rounded-md transition-colors shadow-lg"
          >
            <MessageCircle size={16} /> Message Jacob on Skool <ArrowRight size={16} />
          </a>

          <p className="mt-6 text-xs md:text-sm text-[#6B7280] max-w-xl">
            He&apos;ll get back to you personally.
          </p>
        </div>
      </div>
    </div>
  );
}
